// @need-translate
import dynamic from 'next/dynamic';
import {useRouter} from 'next/router';
import {findIndexOrNull} from '../../../../common/shared/utils/array';
import {PrevTermsLink} from '../../../../domain/policy/presentational/PrevTermsLink';

const Terms_2022_11_11 = dynamic(() =>
  import('./Terms-2022-11-11').then(module => module.Terms)
);

const Terms_2022_09_08 = dynamic(() =>
  import('./Terms-2022-09-08').then(module => module.Terms)
);

/**
 * @raon.c
 * https://github.kakaocorp.com/kakaopage/pageweb/blob/develop/packages/pageweb/src/policy/component/Terms.tsx
 * 현재는 바로 직전 버전만 보여주고 있습니다.
 * 다음 버전을 보여주기 위해서는 아래 주석처리된 코드를 주석 해제하고 TermsConfigList에 추가해주세요.
 */
// const Terms_2021_06_23 = dynamic(() =>
//   import('./Terms-2021-06-23').then(module => module.Terms)
// );

const DEFAULT_TERMS_INDEX = 0;

export function Terms() {
  const router = useRouter();
  const {pathParams} = router.query;
  const termsType = pathParams?.[1];

  const TermsIndex =
    findIndexOrNull(TermsConfigList, ({title}) => title === termsType) ||
    DEFAULT_TERMS_INDEX;

  const TermsComponent = TermsConfigList[TermsIndex].component;

  let nextTermsTitle = undefined;
  if (TermsIndex + 1 < TermsConfigList.length) {
    nextTermsTitle = TermsConfigList[TermsIndex + 1].title;
  }
  const getNextTermsLinkLabel = (nextTermsTitle: string) => {
    const [year, month, day] = nextTermsTitle.split('-');
    return `${year}년 ${month}월 ${day}일 이용약관 보기`;
  };

  return (
    <>
      <TermsComponent />
      {nextTermsTitle && (
        <PrevTermsLink
          url={`/policy/terms/${nextTermsTitle}`}
          linkLabel={getNextTermsLinkLabel(nextTermsTitle)}
        />
      )}
    </>
  );
}

const TermsConfigList = [
  {title: '2022-11-11', component: Terms_2022_11_11},
  {title: '2022-09-08', component: Terms_2022_09_08},
  // {title: '2021-06-23', component: Terms_2021_06_23},
];
